import { Alert } from '@creditornot/cb-alert';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import styled from 'styled-components';

import { WoltModal as Modal } from 'common/components';

export const WoltModal = styled(Modal)`
  width: 700px;
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
`;

const LoadingSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-block-start: 40px;
  padding-block-end: 40px;
`;

export const Loading = () => (
  <LoadingSpinnerContainer>
    <Spinner size="large" />
  </LoadingSpinnerContainer>
);

export const Error = styled(Alert).attrs({ variant: 'error' })`
  width: 100%;
`;
